/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { WeeklyBookingReport } from '../model';
/**
 * OrganisationReportsApi - axios parameter creator
 * @export
 */
export const OrganisationReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *              Returns a list of the next 10 weeks, including the current week, of the total counts for each stock type              The keys within the incoming & outgoing are the products that are associated with the Organisation.             
         * @summary Weekly booking report
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgReportBookingWeeklyList: async (buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgReportBookingWeeklyList', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/report/booking/weekly`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationReportsApi - functional programming interface
 * @export
 */
export const OrganisationReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationReportsApiAxiosParamCreator(configuration)
    return {
        /**
         *              Returns a list of the next 10 weeks, including the current week, of the total counts for each stock type              The keys within the incoming & outgoing are the products that are associated with the Organisation.             
         * @summary Weekly booking report
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgReportBookingWeeklyList(buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WeeklyBookingReport>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgReportBookingWeeklyList(buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationReportsApi - factory interface
 * @export
 */
export const OrganisationReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationReportsApiFp(configuration)
    return {
        /**
         *              Returns a list of the next 10 weeks, including the current week, of the total counts for each stock type              The keys within the incoming & outgoing are the products that are associated with the Organisation.             
         * @summary Weekly booking report
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgReportBookingWeeklyList(buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<Array<WeeklyBookingReport>> {
            return localVarFp.orgReportBookingWeeklyList(buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for orgReportBookingWeeklyList operation in OrganisationReportsApi.
 * @export
 * @interface OrganisationReportsApiOrgReportBookingWeeklyListRequest
 */
export interface OrganisationReportsApiOrgReportBookingWeeklyListRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationReportsApiOrgReportBookingWeeklyList
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof OrganisationReportsApiOrgReportBookingWeeklyList
     */
    readonly aaSource?: string
}

/**
 * OrganisationReportsApi - object-oriented interface
 * @export
 * @class OrganisationReportsApi
 * @extends {BaseAPI}
 */
export class OrganisationReportsApi extends BaseAPI {
    /**
     *              Returns a list of the next 10 weeks, including the current week, of the total counts for each stock type              The keys within the incoming & outgoing are the products that are associated with the Organisation.             
     * @summary Weekly booking report
     * @param {OrganisationReportsApiOrgReportBookingWeeklyListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationReportsApi
     */
    public orgReportBookingWeeklyList(requestParameters: OrganisationReportsApiOrgReportBookingWeeklyListRequest, options?: any) {
        return OrganisationReportsApiFp(this.configuration).orgReportBookingWeeklyList(requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
